"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBadgeStyles = void 0;
var styles_1 = require("./styles");
var getBadgeStyles = function (_a) {
    var variant = _a.variant;
    switch (variant) {
        case 'primary':
            return styles_1.primaryBadgeStyles;
        case 'text':
            return styles_1.textBadgeStyles;
        case 'secondary':
        default:
            return styles_1.secondaryBadgeStyles;
    }
};
exports.getBadgeStyles = getBadgeStyles;
